import { render } from "./ScrollItem.vue?vue&type=template&id=794eca60&scoped=true&ts=true"
import script from "./ScrollItem.vue?vue&type=script&lang=ts"
export * from "./ScrollItem.vue?vue&type=script&lang=ts"

import "./ScrollItem.vue?vue&type=style&index=0&id=794eca60&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/ecom_ecom-offical-website_node_sharelib_cicd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794eca60"]])

export default __exports__